import { ImportTranslations } from "./import-pt-br";

/* eslint-disable max-len */
export const IMPORT_ES_ES: ImportTranslations = {
	title: "Importación de XML",
	invoiceData: {
		title: "Datos de la factura",
		billNumber: "Número de factura",
		noteSeries: "Serie de la factura",
		natureOfOperation: "Naturaleza de la operación",
		accesskey: "Clave de acceso",
		issuer: "Emisor",
		CNPJAndCPF: "CNPJ/CPF",
		noteValue: "Valor de la factura",
		discount: "Descuento",
		totalValue: "Valor total",
		dateInputLabel: "Fecha de entrada en el stock físico:",
	},
	duplicates: {
		title: "Duplicados",
		duplicate: "Duplicado",
		dueDate: "Fecha de vencimiento",
		value: "Valor",
	},
	payment: {
		title: "Pago",
		cashPayment: "Pago al contado",
		installmentsPayment: "Pagos a plazos",
		payment: "Pago",
	},
	ShippingAndExpenses: {
		title: "Envío y gastos",
		shipping: "Envío",
		insurance: "Seguro",
		additionalExpenses: "Gastos adicionales",
	},
	infoCalculator:
		"La base para el cálculo del costo unitario es: Valor total - Descuento + IPI + ICMS + Envío + Seguro + Otros gastos / Cantidad",
	product: {
		amount: "Cantidad",
		quantityAbbr: "Cant",
		commercialUnit: "Unidad de medida",
		unitValue: "Precio por unidad",
		equivalentProduct: "Producto equivalente",
		chartOfAccounts: "Plan de cuentas",
		selectChartOfAccounts: "Seleccione un plan de cuentas",
		noChartOfAccounts: "No hay plan de cuentas disponible",
		equivalentTo: "1 equivale a",
		unitCost: "Costo unitario/{{unit}}",
		paidPerUnit: "Precio por unidad",
		paidPerKg: "Precio por KG",
		totalCost: "Costo total",
		missingProductWarning:
			"Este artículo no está registrado, debe registrarlo antes de continuar.",
		manualQuantityEditWarning: "Cantidad editada manualmente",
		saving: "Guardando...",
	},
	invoiceDetailsFooterButtons: {
		cancel: "Cancelar",
		next: "Siguiente",
	},
	updateInvoiceData: {
		successfullyUpdated: "Datos de la factura actualizados con éxito",
	},
	newProductModal: {
		triggerText: "Haga clic aquí para registrarlo.",
		modalTitle: "Agregar artículo",
		contentText: "¿Qué estás registrando?",
		insumo: {
			title: "Insumo",
			description:
				"Pueden ser utilizados como ingredientes en recetas de otros productos y no aparecen en sus puntos de venta.",
			action: "Haga clic para crear un nuevo insumo",
		},
		produto: {
			title: "Producto",
			description:
				"Productos finales de venta que pueden utilizar, o no, insumos en su producción.",
			action: "Haga clic para crear un nuevo producto",
		},
	},
	saveError:
		"Error al guardar. Verifique si los productos a continuación están correctamente llenados:",
	importError:
		"No se pudo completar la importación, ya que hay productos sin asociación.",
	validation: {
		unitMultiplierRequired: "La cantidad de equivalencia no puede ser 0",
		commercialQuantityRequired: "La cantidad debe ser mayor que 0",
		associatedProductRequired: "El producto debe estar asociado a un producto",
	},
};
